// Maps a charge's `autoTrigger` (the clinical event that fired it) to doctor-facing
// language: 'dx-fees' is raised when the doctor approves the case, not at shipping.
const MILESTONE_LABELS: Record<string, string> = {
    'case-design': 'Case design approved',
    'dx-fees': 'Treatment approved',
    orthopulse: 'OrthoPulse',
    retainers: 'Retainers delivered'
};

interface ChargeMilestoneSource {
    autoTrigger: string | null;
    description: string | null;
}

export function chargeMilestoneLabel(charge: ChargeMilestoneSource): string {
    if (charge.autoTrigger && MILESTONE_LABELS[charge.autoTrigger]) {
        return MILESTONE_LABELS[charge.autoTrigger];
    }
    return charge.description ?? 'Charge';
}
